import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { IHistoricoUGK } from '../models/hisguk';
import { IpostGestionKilometraje } from '../models/guardargestionkilometraje';

@Injectable({
  providedIn: 'root'
})
export class GestionkilometrajeService {
  private apiUrl: string ='';
  constructor(private _http: HttpClient) {
    this.apiUrl = environment.SUrlgApi + 'GestionKilometraje';
  }

getUnidades(cod_usuario: string): Observable<any[]> {
  const params = new HttpParams().set('cod_usuario', cod_usuario);

  return this._http
    .get<any[]>(this.apiUrl + '/getUnidadesGestionKilometraje', { params })
    .pipe(retry(1), catchError(this.handleError));
}



 public guardarKilometraje(data:IpostGestionKilometraje):Observable<any>{

    const headers = { 'content-type': 'application/json'}
    const body = JSON.stringify(data);
    return this._http.post<any>(this.apiUrl + '/postGestionKilometraje/',body,{'headers':headers});
   }




  getHistorico(id_unidad_transporte: number,fec_inicio : string, fec_fin:string): Observable<IHistoricoUGK[]> {
  const params = new HttpParams()
  .set('id_unidad_transporte', id_unidad_transporte)
 .set('fec_inicio', fec_inicio)
  .set('fec_fin', fec_fin);
  return this._http
    .get<IHistoricoUGK[]>(this.apiUrl + '/getHisUGK', { params })
    .pipe(retry(1), catchError(this.handleError));
}

  getRptGestionKilometraje(id_unidad_transporte: number,fec_inicio : string, fec_fin:string): Observable<any[]> {
    const valores = {
      params: new HttpParams()
      .set('id_unidad_transporte', id_unidad_transporte)
         .set('fec_inicio', fec_inicio)
          .set('fec_fin', fec_fin)
    };
    return this._http
      .get<any[]>(this.apiUrl + '/getRptUGK',valores);
  }

    generarReporte(fec_inicio : string, fec_fin:string): Observable<any[]> {
    const valores = {
      params: new HttpParams()

         .set('fec_inicio', fec_inicio)
          .set('fec_fin', fec_fin)
    };
    return this._http
      .get<any[]>(this.apiUrl + '/getRptGestionKilometraje',valores);
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
